<template>
  <b-row>
    <b-col v-if="!editingDescription" cols="auto">
      <p class="tsny_text">
        {{ description || "This course doesn't have a description" }}
      </p>
    </b-col>
    <b-col v-if="!editingDescription" cols="auto"
      ><i
        class="fa fa-edit float-left tsny_icon"
        @click="startUpdateDescription"/></b-col
    ><b-col v-if="editingDescription" class="col">
      <b-row class="mb-3">
        <b-col>
          <b-textarea
            v-model="description"
            class="tsny_input-text-area tsny_text"
            placeholder="This course doesn't have a description"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="float-right">
            <b-button
              class="btn-sm tsny_button tsny_button-cancel"
              @click="cancelUpdateDescription"
              >Cancel</b-button
            >
            <b-button
              class="btn-sm tsny_button margin-left"
              @click="updateDescription"
              >Save Changes</b-button
            >
          </div>
        </b-col>
      </b-row>
      <b-row v-if="editDescriptionError">
        <b-col>
          <p class="tsny_status-text">
            There was an error saving the updated course description. This may
            occur if you attempt to save an unchanged description
          </p>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import CourseRestService from "../../services/rest/services/CourseRestService";

export default {
  name: "EditDescription",
  props: {
    value: {
      type: String,
      default: null
    },
    courseId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    description: null,
    editingDescription: false,
    editDescriptionError: false,
    tempDescription: null
  }),
  created() {
    this.description = this.value;
  },
  watch: {
    courseId() {
      let $comp = this;
      $comp.description = $comp.value;
      $comp.editingDescription = false;
      $comp.editDescriptionError = false;
    }
  },
  methods: {
    startUpdateDescription: function() {
      let $comp = this;
      $comp.tempDescription = $comp.description;
      $comp.editingDescription = true;
    },
    updateDescription: function() {
      let $comp = this;
      return CourseRestService.updateDescription(
        $comp.courseId,
        $comp.description
      )
        .then(() => {
          $comp.editingDescription = false;
          $comp.editDescriptionError = false;
        })
        .catch(err => {
          console.log(err);
          $comp.editDescriptionError = true;
        });
    },
    cancelUpdateDescription: function() {
      let $comp = this;
      $comp.description = $comp.tempDescription;
      $comp.editingDescription = false;
      $comp.editDescriptionError = false;
    }
  }
};
</script>

<style scoped></style>
